// 按钮系统切换
$('.banner .banner_tab span').click(function(){
    if($(this).index()==1){
        $('.banner .banner_tab .bg').addClass('active')
    }else{
        $('.banner .banner_tab .bg').removeClass('active')
    }
    $(this).addClass('active').siblings('span').removeClass('active')
    $('.banner .btn_box>div').eq($(this).index()).addClass('active').siblings().removeClass('active')
    $('.fix_bar .btn_box>div').eq($(this).index()).addClass('active').siblings().removeClass('active')
})
if($('.banner_tab .sys_mac').hasClass('active')){
    $('.banner .banner_tab>i.bg').addClass('active')
}else{
    $('.banner .banner_tab>i.bg').removeClass('active')
}

// 平台切换
$(document).ready(function() {
    var currentIndex = 0;
    var $items = $('.platform_ul>li');
    $items.click(function() {
        var index = $('.platform_ul>li').index($(this));
        $items.removeClass('active');
        $(this).addClass('active');
        currentIndex = index;
    });
    $('.platform .arrow i.right').click(function() {
        currentIndex = (currentIndex + 1) % $items.length;
        $items.eq(currentIndex).click();
    });
    $('.platform .arrow i.left').click(function() {
        currentIndex = (currentIndex - 1 + $items.length) % $items.length;
        $items.eq(currentIndex).click();
    });
});


// step
$(document).ready(function() {
    $('.step .title').click(function() {
        var index = $(this).parents('.step').index();
        var tabsCount = $('.step').length;
        var nextIndex = (index ) % tabsCount;
        $('.step').removeClass('active');
        $('.tab_btn i').removeClass('active');
        $(this).parents('.step').addClass('active');
        $('.step_img').removeClass('active');
        $('.step.active').parents('ul').parents('.step_content').siblings('.img_box').find('.step_img').eq(nextIndex).addClass('active');
        $('.step.active').parents('ul').parents('.step_content').siblings('.img_box').find('.tab_btn').find('i').eq(nextIndex).addClass('active');
    });
    $('.tab_btn i').click(function() {
        var index1 = $(this).index();
        var tabsCount1 = $('.step').length;
        var nextIndex1 = (index1 ) % tabsCount1;
        $('.step').removeClass('active');
        $('.tab_btn i').removeClass('active');
        $('.step_img').removeClass('active');
        $(this).addClass('active');
        $(this).parents('.tab_btn').parents('.img_box').siblings('.step_content').find('.step').eq(nextIndex1).addClass('active');
        $(this).parents('.tab_btn').parents('.img_box').find('.step_img').eq(nextIndex1).addClass('active');
    });

    function autoChangeTab() {
      var $activeTab = $('.step.active');
      var index = $activeTab.index();
      var tabsCount = $('.step').length;
      var nextIndex = (index + 1) % tabsCount;
      $('.step').eq(nextIndex).find('.title').click();
    }
    setInterval(autoChangeTab, 4000);
});


// faq
$('.faq li').click(function(){
    $(this).find('.info').slideToggle().parent().siblings().find('.info').slideUp();
    $(this).toggleClass('active').siblings().removeClass('active');
});
$('.faq li .info').click(function(e){
    e.stopPropagation();
});


// 冻结条
(function(){
    if($(window).width() <=1440){
        $('.fix_bar>.container').click(function(){
            if($(this).hasClass('active')){
                $('.fix_bar .fix_right').hide();
                $(this).removeClass('active');
            }else{
                $('.fix_bar .fix_right').show();
                $(this).addClass('active');
            }
        });
    }
})();

$(window).scroll(throttle(function(){
    if($(window).scrollTop() >= $('.screen_two').offset().top - 100){
       $('.fix_bar').show();
    }else{
       $('.fix_bar').hide();
}
    
},300));
function throttle(fn,speed){
    var timer = null;
    return function(){
        var that = this;
        var arg = arguments;
        if(!timer){
           timer = setTimeout(function(){fn.call(that,arg);timer = null;},speed)
        }
    }
}